import './App.css';
import {useState} from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route
} from "react-router-dom";
import {NavBar} from "./Components/NavBar";
import {Footer} from "./Components/Footer";
import {About} from "./Components/About";
import {Feedback} from "./Components/Feedback";
import {Content} from "./Components/ContentPage";
import {ContactEn, ContactRu} from "./Components/Utils";
import ScrollToTop from "./Components/ScrollToTop";
import FlashMediaRU from './Components/FlashMedia/RU';
import FlashMediaEN from './Components/FlashMedia/EN';
import FlashClientRU from './Components/FlashClient/RU';
import AboutCompanyRU from './Components/AboutCompany/RU';
import AboutCompanyEN from './Components/AboutCompany/EN';
import './styles/_fonts.sass';

function App() {
    const [Lang, setLang] = useState('ru');
    const [IsOpenMenu, setIsOpenMenu] = useState(false);
    const Pages = {
        'flashpay2b': {
            'ru': {
                'imgUrl': './scheme_B2B.svg',
                'title': 'FlashPay2B',
                'subtitle': 'Программный продукт предназначен для реализации на торговых объектах и сетях АЗС бесконтактной системы оформления заказа и дальнейшей оплаты топлива/товаров для юридических лиц с помощью мобильного приложения.',
                'text': 'Система состоит из ядра платформы процессингового центра, базы данных, серверной части системы, личного кабинета клиента и оператора системы, модуля отчетности, интегрированной системы бесконтактной авторизации клиента FlashID “одним взглядом”, API для интеграции внешних АСУ партнеров с работой процессингового центра, мобильного приложения. Также возможна доработка под ваши нужды, в части модулей интеграции с АСУ АЗС, банком, магазином, системой бухучета и т.п.'
            },
            'en': {
                'imgUrl': './scheme_B2B.svg',
                'title': 'FlashPay2B',
                'subtitle': 'This software product is designed for integration with convenience stores and gas station networks of a contactless ordering system and payment for the fuel or goods by business clients using a mobile application.',
                'text': 'The product consists of the core of the processing center platform, database, server part of the system, personal account of the client and the system operator, reporting module, integrated contactless client authorization FlashID - “At-A-Glance”, API for integrating external ACS of partners with the jobs of the processing center, mobile application. It is also possible to customize it for your special requirements, in terms of integration modules with the automated control system of a gas station, a bank, a convenience store, an accounting system, e.t.c.'
            }
        },
        'flashpay2c': {
            'ru': {
                'imgUrl': './scheme_B2C.svg',
                'title': 'FlashPay2C',
                'subtitle': 'Программный продукт предназначен для создания бесконтактной системы управления заказами на торговых объектах и сетях АЗС, на базе мобильного приложения для физ.лиц.',
                'text': 'Продукт состоит из ядра платформы процессингового центра, индивидуально настраиваемой системы клиентской лояльности, базы данных, серверной части, API для интеграции с автоматизированной системой учета клиентов и другими внешними системами, мобильным приложением (Android, iOS) для использования конечным клиентом (физическим лицом). Проинтегрирован с системой бесконтактной авторизации клиента «одним взглядом» - FlashID. Возможна доработка под нужды каждого клиента в части модулей интеграции с АСУ АЗС, банком, ОФД, кассой, магазином, системой бухучета.'
            },
            'en': {
                'imgUrl': './scheme_B2C.svg',
                'title': 'FlashPay2C',
                'subtitle': 'This software is designed to create a contactless order management system at convenience stores and gas station networks, based on a mobile application for individuals.',
                'text': 'The product consists of the core of the processing center platform, an individually configurable customer loyalty system, a database, a server part, an API for integration with an automated customer accounting system and other external systems, a mobile application (Android, iOS) for use by the end customer (an individual). Integrated with the system of contactless authorization of the client "At-A-Glance" - FlashID. It is also possible to customize it for your special requirements, in terms of integration modules with the automated control system of a gas station, a bank, a convenience store, an accounting system, e.t.c.'
            }
        },
        'flashid': {
            'ru': {
                'title': 'FlashID',
                'subtitle': 'Модульный продукт, состоящий из авторизационного терминала (hardware) и программного модуля распознавания лиц (software). Технология FlashID может интегрироваться в существующие системы управления лояльностью клиентов, как отдельностоящий продукт. ' +
                    'Данная технология предназначена для реализации на торговых объектах и сетях АЗС бесконтактной системы авторизации клиента "одним взглядом" - для автоматического оформления заказа и его оплаты.',
                'text': 'Система состоит из API готового для интеграции с внешними системами управления (мобильным приложением, системой управления продажами товаров АЗС или ритейла), серверной части управления процессами авторизации клиентов. ' +
                    'Уникальность технологии подтверждается патентной заявкой № 2021104766.',
                'link': 'https://youtu.be/5kfDiHJuNsk',
                'linktext': 'Видео презентация технологии'
            },
            'en': {
                'title': 'FlashID',
                'subtitle': 'A modular product consisting of an authorization terminal and facial recognition software. FlashID technology can be integrated into existing customer loyalty management systems as a stand-alone product. This technology is designed for the implementation of a contactless customer authorization system "At-A-Glance" at convenience stores and gas station networks - for automatic order processing and fast payment.',
                'text': 'The system consists of an API that integrates with external management systems (a mobile application, a gas station or retail sales management system), a server part for managing customer authorization processes. The uniqueness of the technology is confirmed by patent pending No. W21010533.',
                'link': 'https://youtu.be/5kfDiHJuNsk',
                'linktext': 'Video presentation of technology'
            }
        },
        // 'flashtalk': {
        //     'ru': {
        //         'title': 'FlashTalk',
        //         'subtitle': 'Это мобильное приложение, позволяющее в любой компании развернуть собственную защищённую платформу обмена текстовыми и голосовыми сообщениями; фото и видео материалами; голосовыми, видео и групповыми вызовами; создавать виртуальные комнаты для переговоров. Также возможно использование вэб-версии приложения.',
        //         'text': 'В систему встроены надежные механизмы сквозного шифрования всей информации абонентов, что позволяет сохранить все передаваемые данные в безопасности.'
        //     },
        //     'en': {
        //         'title': 'FlashTalk',
        //         'subtitle': 'It is a mobile application that allows any company to deploy its own secure platform for exchanging text and voice messages, photo and video content; make voice, video and group calls; create virtual meeting rooms. It also has a web version of the application.',
        //         'text': 'The system has built-in reliable mechanisms for end-to-end encryption of all user’s information, which allows keeping all transmitted data safe and secure.'
        //     }
        // },
        'flashmedia': {
            'ru': {
                'title': 'Програмное обеспечение «FlashMedia»',
                'subtitle': '',
                'component': FlashMediaRU
            },
            'en': {
                'title': 'Software «FlashMedia»',
                'subtitle': '',
                'component': FlashMediaEN
            }
        },
        'flashclient': {
            'ru': {
                //'imgUrl': './scheme_FlashClient.svg',
                'title': 'FlashClient',
                'subtitle': 'Продукт предназначен для автоматической фиксации и сопоставления операции покупки топлива с покупателем и его автомобилем.',
                'component': FlashClientRU
                //'text': 'Модульный продукт, состоит из камеры для распознавания автомобильных номеров (hardware) и программного обработчика данных (software). ' +
                //    'Данное решение позволяет создать связь между покупкой топлива за наличные с данными об автомобиле и его владельце в момент покупки. Что, в свою очередь, позволяет лучше узнать своих клиентов и повышает прозрачность клиентской базы.'
            },
            'en': {
                'imgUrl': './scheme_FlashClient.svg',
                'title': 'FlashClient',
                'subtitle': 'The product is designed to automatically record and compare the fuel purchase operation with the buyer and his car. The modular product consists of a camera for recognizing car license plates and a software data processor.',
                'text': 'This solution allows you to create a link between the purchase of fuel for cash with data about the car and its owner at the time of purchase. This, in turn, allows you to get to know your customers better and increases the transparency of the customer base.'
            }
        },
        'aboutcompany': {
            'ru': {
                'title': 'О компании',
                'subtitle': '',
                'component': AboutCompanyRU,
            },
            'en': {
                'title': 'About company',
                'subtitle': '',
                'component': AboutCompanyEN,
            }
        },
        'solutions': {
            'ru': {
                'title': 'Решения',
                'subtitle': '',
                'text': 'Уже несколько лет мы разрабатываем и интегрируем новые технологии в системы учета наших клиентов - топливных компаний, сетей АЗС и ритейла. Наши решения созданы для новой реальности, где клиенты предпочитают совершать безопасные покупки товаров и топлива, с помощью мобильных приложений и как можно меньше взаимодействовать с другими людьми.'
            },
            'en': {
                'title': 'Solutions',
                'subtitle': '',
                'text': 'For several years now, we have been developing and integrating new technologies into the accounting systems of our customers - fuel companies, gas station networks, and convenience stores. Our solutions are designed for a new reality, where customers prefer to make safe purchases of goods and fuel using mobile applications and interact with other people as little as possible.'
            }
        },
        'contacts': {
            'ru': {
                'title': 'Контакты',
                'subtitle': '',
                'component': ContactRu
            },
            'en': {
                'title': 'Contacts',
                'subtitle': '',
                'component': ContactEn
            }
        }
    };
    return (
        <Router>
            <div className={'main'}>
                <NavBar Lang={Lang} senLang={setLang} isopenmenu={IsOpenMenu} setisopenmenu={setIsOpenMenu}/>
                <div className={IsOpenMenu ? 'container blur-container' : 'container'}>
                    <ScrollToTop>
                        <Switch>
                            <Route exact path="/">
                                <About Lang={Lang}/>
                            </Route>
                            <Route path="/feedback">
                                <Feedback Lang={Lang}/>
                            </Route>
                            <Route path="/flashpay2b">
                                <Content {...Pages['flashpay2b'][Lang]} Lang={Lang}/>
                            </Route>
                            <Route path="/flashpay2c">
                                <Content {...Pages['flashpay2c'][Lang]} Lang={Lang}/>
                            </Route>
                            <Route path="/flashmedia">
                                <Content {...Pages['flashmedia'][Lang]} Lang={Lang}/>
                            </Route>
                            <Route path="/flashclient">
                                <Content {...Pages['flashclient'][Lang]} Lang={Lang}/>
                            </Route>
                            {/* <Route path="/flashtalk">
                                <Content {...Pages['flashtalk'][Lang]} Lang={Lang}/>
                            </Route> */}
                            <Route path="/flashid">
                                <Content {...Pages['flashid'][Lang]} Lang={Lang}/>
                            </Route>
                            <Route path="/aboutcompany">
                                <Content {...Pages['aboutcompany'][Lang]} Lang={Lang}/>
                            </Route>
                            <Route path="/solutions">
                                <Content {...Pages['solutions'][Lang]} Lang={Lang}/>
                            </Route>
                            <Route path="/contacts">
                                <Content {...Pages['contacts'][Lang]} Lang={Lang}/>
                            </Route>
                        </Switch>
                    </ScrollToTop>
                </div>
                <Footer Lang={Lang} setLang={setLang}/>
            </div>
        </Router>
    );
}

export default App;
